export const filterNavDirect = () => {
  const filterDropDown = document.getElementById('filter-dropdown');

  const params = new URLSearchParams(window.location.search);

  // UPDATING VALUE OF SELECT ACC TO PAGE
  if (params.size === 0) filterDropDown.value = 'all';
  else if (params.get('sort') === 'discountedPrice')
    filterDropDown.value = 'low-to-high';
  else filterDropDown.value = 'high-to-low';

  // EVENT LISTENER
  filterDropDown.addEventListener('change', (e) => {
    if (e.target.value === 'low-to-high') {
      window.location.href = `${window.location.protocol}//${window.location.host}${window.location.pathname}?sort=discountedPrice`;
    } else if (e.target.value === 'high-to-low')
      window.location.href = `${window.location.protocol}//${window.location.host}${window.location.pathname}?sort=-discountedPrice`;
    else
      window.location.href = `${window.location.protocol}//${window.location.host}${window.location.pathname}`;
  });
};
